export default class NumberExpression {
    private decimalShift: number;
    private roundedTarget: number;
    private exchangeRate: number;

    public constructor(
        target: number,
        precision: number,
        exchangeRate: number
    ) {
        this.decimalShift = Math.pow(10, precision);
        this.roundedTarget = this.round(target);
        this.exchangeRate = exchangeRate;
    }

    public testEqual(n: number) {
        return this.round(this.localValue(n)) === this.roundedTarget;
    }

    public testNotEqual(n: number) {
        return !this.testEqual(this.localValue(n));
    }

    public testLessThan(n: number) {
        return this.round(this.localValue(n)) < this.roundedTarget;
    }

    public testLessThanOrEqual(n: number) {
        return this.round(this.localValue(n)) <= this.roundedTarget;
    }

    public testGreaterThan(n: number) {
        return this.round(this.localValue(n)) > this.roundedTarget;
    }

    public testGreaterThanOrEqual(n: number) {
        return this.round(this.localValue(n)) >= this.roundedTarget;
    }

    private round(n: number) {
        return Math.round(n * this.decimalShift);
    }

    private localValue(n: number): number {
        return n * this.exchangeRate;
    }
}
